<script setup lang="ts">
import { defineQuery } from "groq";

const BOOKS_QUERY = defineQuery(
  `*[_type == "book"]{..., author->{name, slug}}`
);
const { data: books } = await useSanityQuery(BOOKS_QUERY);
</script>

<template>
  <UContainer>
    <h1
      class="font-serif text-lg tracking-wide dark:text-gray-200 text-gray-600 mt-6"
    >
      Books
    </h1>
    <section class="mt-2">
      <NuxtLink
        v-for="book in books"
        :key="book._id"
        :href="`/books/${book.slug?.current}`"
      >
        <h3 class="text-2xl font-semibold font-serif">{{ book.title }}</h3>
        <p v-if="book.author" class="text-gray-500">
          by {{ book.author.name }}
        </p>
      </NuxtLink>
    </section>
  </UContainer>
</template>
